<template>
    <a-card :bordered="false" class="bl-card" :style="selectedOfferKeys.length && { marginBottom: '60px' }">
        <div class="bl-filterbar">

            <a-input
                class="bl-search-input"
                placeholder="Buscar por produto"
                v-model="search"
                allow-clear
            />

            <a-select
                class="fl-filter-select fl-filter-select-loja fixed-height-select"
                placeholder="Todas as lojas"
                v-model="storeFilter"
                mode="multiple"
                allow-clear
                show-search
                option-filter-prop="children"
                :dropdown-style="{ minWidth: '300px' }"
            >
                <a-select-option v-for="store in stores" :key="store.id" :value="store.id">
                    {{ store.name }}
                </a-select-option>
            </a-select>

            <a-select
                class="fl-filter-select fixed-height-select"
                placeholder="Reabastecimento"
                v-model="replenishmentFilter"
                mode="multiple"
                allow-clear
            >
                <a-select-option v-for="option in replenishmentOptions" :key="option.key" :value="option.key">
                    {{ option.label }}
                </a-select-option>
            </a-select>

            <div class="bl-stats">
                <span class="bl-stat"><b>{{ filteredProducts.length }}</b> produtos</span>
                <span class="bl-stat"><b>{{ filteredTotal | currency }}</b></span>
            </div>
        </div>
        <a-table
            size="small"
            :columns="columns"
            :data-source="filteredProducts"
            row-key="key"
            :loading="products_loading"
            :pagination="pagination"
            :expand-icon-column-index="1"
            :locale="{ emptyText: 'Nenhum pré-pedido pendente.' }"
        >
            <template slot="selecionarHeader">
                <a-checkbox
                    :checked="isAllFullySelected()"
                    :indeterminate="isAllPartiallySelected()"
                    @change="toggleAllSelection($event.target.checked)"
                />
            </template>

            <template slot="selecionar" slot-scope="text, product">
                <a-checkbox
                    :checked="isProductFullySelected(product)"
                    :indeterminate="isProductPartiallySelected(product)"
                    @change="toggleProductSelection(product, $event.target.checked)"
                />
            </template>

            <template slot="produto" slot-scope="text, product">
                <div class="pro-name">
                    {{ product.name }}

                    <span class="brand" v-if="product.brand">
                        {{ product.brand }}
                    </span>
                </div>
                <div class="pro-ean" v-if="product.ean || product.internal_code">
                    <template v-if="product.ean">EAN {{ product.ean }}</template>
                    <template v-if="product.ean && product.internal_code"> · </template>
                    <template v-if="product.internal_code">Cód. {{ product.internal_code }}</template>
                </div>
            </template>

            <template slot="ressuprimento" slot-scope="text, product">
                <span class="repl-tag" v-if="replenishment(product)">
                    {{ replenishment(product) }}
                </span>

                <span v-else>--</span>
            </template>

            <template slot="fornecedores" slot-scope="text, product">{{ product.fornecedores.length }}</template>

            <template slot="total" slot-scope="text, product">{{ productTotal(product) | currency }}</template>

            <template slot="acoes" slot-scope="text, product">
                <ActionMenu :actions="produtoActions(product)" />
            </template>

            <template slot="expandedRowRender" slot-scope="product">
                <div class="expanded-table-wrapper">
                    <a-table
                        size="small"
                        :columns="fornecedorColumns"
                        :data-source="product.fornecedores"
                        row-key="key"
                        :pagination="false"
                        :expand-icon-column-index="1"
                    >
                        <template slot="selecionar" slot-scope="text, fornecedor">
                            <a-checkbox
                                :checked="isFornecedorFullySelected(fornecedor)"
                                :indeterminate="isFornecedorPartiallySelected(fornecedor)"
                                @change="toggleFornecedorSelection(fornecedor, $event.target.checked)"
                            />
                        </template>

                        <template slot="fornecedor" slot-scope="text, fornecedor">
                            <div class="bl-sup">
                                <span class="bl-n">
                                    {{ fornecedor.provider_name }}<template v-if="fornecedor.provider_cnpj"> · {{ fornecedor.provider_cnpj }}</template>
                                </span>
                                <span class="bl-v" v-if="fornecedor.seller_name">
                                    {{ fornecedor.seller_name }}
                                </span>
                            </div>
                        </template>

                        <template slot="embalagem" slot-scope="text, fornecedor">
                            {{
                                fornecedor.purchase_unity ||
                                `${fornecedor.packing.split(" ")[0]} ${fornecedor.packing.split(" ")[1]}`
                            }}
                        </template>

                        <template slot="valor_unitario" slot-scope="text, fornecedor">{{ fornecedor.offer_price | currency }}</template>

                        <template slot="ultimaCompra" slot-scope="text, fornecedor">
                            <span v-if="fornecedor.last_purchase != null">{{ fornecedor.last_purchase | currency }}</span>
                            <span v-else>—</span>
                        </template>

                        <template slot="diferenca" slot-scope="text, fornecedor">
                            <span v-if="fornecedor.last_purchase != null" :class="deltaClass(fornecedor)">
                                {{ (fornecedor.offer_price - fornecedor.last_purchase) | currency }}
                            </span>
                            <span v-else>—</span>
                        </template>

                        <template slot="variacao" slot-scope="text, fornecedor">
                            <span v-if="fornecedor.last_purchase != null" :class="deltaClass(fornecedor)">
                                {{ variation(fornecedor).toFixed(1) }}%
                            </span>
                            <span v-else>—</span>
                        </template>

                        <template slot="cond" slot-scope="text, fornecedor">{{ fornecedor.payment_condition || "-" }}</template>

                        <template slot="entrega" slot-scope="text, fornecedor">{{ deliveryDate(fornecedor) }}</template>

                        <template slot="tipoEntrega" slot-scope="text, fornecedor">{{ fornecedor.delivery_type || "—" }}</template>

                        <template slot="faturamentoMinimo" slot-scope="text, fornecedor">
                            <span v-if="fornecedor.minimumBilling">{{ fornecedor.minimumBilling | currency }}</span>
                            <span v-else>-</span>
                        </template>

                        <template slot="lojas" slot-scope="text, fornecedor">{{ fornecedor.lojas.length }}</template>

                        <template slot="valor" slot-scope="text, fornecedor">{{ fornecedorTotal(fornecedor) | currency }}</template>

                        <template slot="acoes" slot-scope="text, fornecedor">
                            <ActionMenu :actions="fornecedorActions(product, fornecedor)" />
                        </template>

                        <template slot="observacao" slot-scope="text, fornecedor">
                            <a-tooltip v-if="fornecedor.observations">
                                <template slot="title">
                                    {{ fornecedor.observations }}
                                </template>

                                <span class="obs-text">{{ fornecedor.observations }}</span>
                            </a-tooltip>

                            <span v-else>—</span>
                        </template>

                        <template slot="expandedRowRender" slot-scope="fornecedor">
                            <div class="expanded-table-wrapper">
                                <a-table
                                    size="small"
                                    :columns="lojaColumns"
                                    :data-source="fornecedor.lojas"
                                    row-key="key"
                                    :pagination="false"
                                    :row-selection="lojaRowSelection(fornecedor)"
                                >
                                    <template slot="loja" slot-scope="text, offer">
                                        <div class="bl-strong">{{ storeName(offer.store_id) }}</div>
                                    </template>

                                    <template slot="estoque" slot-scope="text, offer">
                                        <span v-if="offer.inventory != null">{{ offer.inventory | stock }}</span>
                                        <span v-else>—</span>
                                    </template>

                                    <template slot="requisicao" slot-scope="text, offer">
                                        {{ offer.request_quantity != null ? offer.request_quantity : "—" }}
                                    </template>

                                    <template slot="quantidade" slot-scope="text, offer">
                                        <span class="matrix-qty-wrap" :class="{ saved: !!savedCells[`${offer.id}-${offer.store_id}-${offer.provider_id}-${offer.seller_id}`] }">
                                            <a-input
                                                :min="0"
                                                data-field="produto-qty"
                                                class="matrix-qty-input"
                                                v-model="offer.requested_quantity"
                                                @input="handleQuantityInput($event, offer)"
                                                @blur="saveQuantity(offer)"
                                                @keydown.native="handleQtyKeydown($event)"
                                                @focus="handleFocus(offer)"
                                            />
                                        </span>
                                    </template>

                                    <template slot="total" slot-scope="text, offer">{{ offerTotal(offer) | currency }}</template>

                                    <template slot="acoes" slot-scope="text, offer">
                                        <ActionMenu :actions="offerActions(offer)" />
                                    </template>
                                </a-table>
                            </div>
                        </template>
                    </a-table>
                </div>
            </template>
        </a-table>

        <NegotiationModal
            v-if="negotiationModal.open"
            :product="negotiationModal.product"
            :typing="negotiationModal.winner"
            :quotation_id="$route.params.id"
            @close="closeNegotiation"
        />

        <ProductWrapModal
            v-if="wrapModal.open"
            :product="wrapModal.product"
            :salesman="wrapModal.winner"
            @close="closeWrap"
        />

        <ChangeWinnerModal
            v-if="changeWinnerModal.open"
            :product="changeWinnerModal.product"
            :pre-orders="products"
            :quotation-id="$route.params.id"
            @close="closeChangeWinner"
            @saved="onWinnerChanged"
        />

        <TypedProductsModal
            v-if="typedProductsModal.open"
            :quotation-id="$route.params.id"
            :provider-id="typedProductsModal.providerId"
            :provider-name="typedProductsModal.providerName"
            :seller-id="typedProductsModal.sellerId"
            :seller-name="typedProductsModal.sellerName"
            @close="closeTypedProducts"
            @reload="$emit('reload')"
        />

        <SellerPreOrderModal
            v-if="sellerPreOrderModal.open"
            :provider="sellerPreOrderModal.provider"
            :stores="stores"
            :quotation-id="$route.params.id"
            :generating="generating"
            @close="closeSellerPreOrder"
            @reload="$emit('reload')"
            @generate-orders="(keys) => $emit('generate-orders', keys)"
        />

        <ProductOrdersModal
            v-if="historyModal.open"
            :product_id="historyModal.productId"
            :product_name="historyModal.productName"
            @close="historyModal.open = false"
        />

        <AddProductPickerModal
            v-if="addProductModal.open"
            :quotation-id="$route.params.id"
            :provider-name="addProductModal.provider.nomeFornecedor"
            :seller-name="addProductModal.provider.nomeVendedor"
            :exclude-ids="addProductModal.provider.products.flatMap((p) => [p.id, p.main_product_id]).filter(Boolean)"
            @close="closeAddProduct"
            @select="openDistributionForNewProduct"
        />

        <StoreQuantityModal
            v-if="distributionModal.open"
            :winner="distributionModal.winner"
            :product="distributionModal.product"
            :quotation-id="$route.params.id"
            :mark-winner-on-save="distributionModal.markWinnerOnSave"
            @close="closeDistribution"
            @saved="onDistributionSaved"
            @price-updated="$emit('reload')"
        />

        <SelectionFooter
            :count="selectedOffers.length"
            item-label="ofertas selecionadas"
        >
            <template slot="summary">
                <strong>{{ selectedTotal | currency }}</strong>
            </template>

            <template slot="actions">
                <a-button size="large" @click="setSelection([])">Limpar seleção</a-button>
                <a-button size="large" @click="bulkExport">Exportar</a-button>
                <a-button size="large" @click="bulkZeroQuantity">Zerar quantidade</a-button>
                <a-button size="large" :loading="refreshingErp" :disabled="refreshingErp || generating" @click="$emit('refresh-erp', selectedOfferKeys)">Atualizar estoque/custo</a-button>
                <a-button size="large" type="primary" :disabled="generating" @click="bulkGenerateOrder">Gerar pedido</a-button>
            </template>
        </SelectionFooter>
    </a-card>
</template>

<script>
import QuotationService from "@/services/QuotationService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import currencyPrecision from "@/mixins/currencyPrecision";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { replenishmentStrategyMixin } from "@/mixins/replenishment-strategy.mixin";
import { replenishmentLabel } from "@/helpers/replenishment";
import { buildSellerProviderMatrix } from "@/helpers/seller-provider-matrix";
import NegotiationModal from "@/modals/negotiate-offer/negotiate-offer.modal.vue";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal.vue";
import ChangeWinnerModal from "@/modals/change-winner/change-winner.modal.vue";
import TypedProductsModal from "./_typed-products.modal.vue";
import SellerPreOrderModal from "./_seller-pre-order.modal.vue";
import ProductOrdersModal from "@/modals/products/orders";
import StoreQuantityModal from "../comparativo/_store-quantity.modal.vue";
import AddProductPickerModal from "./_add-product-picker.modal.vue";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import SelectionFooter from "@/components/cliente/monitors/SelectionFooter.vue";

const PRICE_LOCKED_TOOLTIP = "Pedido já gerado com este fornecedor — preço travado";

export default {
    name: "ByProdutoTable",
    mixins: [currencyPrecision, loaderMixin, replenishmentStrategyMixin],
    components: { NegotiationModal, ProductWrapModal, ChangeWinnerModal, TypedProductsModal, SellerPreOrderModal, ProductOrdersModal, StoreQuantityModal, AddProductPickerModal, ActionMenu, SelectionFooter },
    props: {
        // Fetched once by the parent (_pre-orders.tab.vue) and shared with
        // Matriz/Analítico/Por loja (nova API) — same pre_orders_report()
        // call for all four, see [[winners-v2-backlog-triage]].
        products: {
            type: Array,
            default: () => [],
        },
        products_loading: {
            type: Boolean,
            default: false,
        },
        orderedOffers: {
            type: Object,
            default: () => ({}),
        },
        // Another generate-orders call (from this view or a sibling one) is
        // still in flight — blocks new ones so an early reload can't run
        // while a later request is still writing [[pre-orders-generate-race]].
        generating: {
            type: Boolean,
            default: false,
        },
        refreshingErp: {
            type: Boolean,
            default: false,
        },
        pendencyOnly: {
            type: Boolean,
            default: false,
        },
        selectedOfferKeys: {
            type: Array,
            default: () => [],
        },
        savedCells: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            stores: [],
            groupedProducts: [],
            svc: new QuotationService(),
            sending: {},
            search: "",
            storeFilter: [],
            replenishmentFilter: [],
            pagination: {
                pageSize: 50,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                locale: {
                    items_per_page: '/ página',
                },
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
            },
            negotiationModal: {
                open: false,
                winner: null,
                product: null,
            },
            wrapModal: {
                open: false,
                winner: null,
                product: null,
            },
            changeWinnerModal: {
                open: false,
                product: null,
            },
            historyModal: {
                open: false,
                productId: null,
                productName: "",
            },
            typedProductsModal: {
                open: false,
                providerId: null,
                providerName: "",
                sellerId: null,
                sellerName: "",
            },
            sellerPreOrderModal: {
                open: false,
                provider: null,
            },
            addProductModal: {
                open: false,
                provider: null,
            },
            distributionModal: {
                open: false,
                winner: null,
                product: null,
                markWinnerOnSave: false,
            },
        };
    },
    computed: {
        columns() {
            return [
                { title: "", key: "selecionar", width: 40, align: "center", slots: { title: "selecionarHeader" }, scopedSlots: { customRender: "selecionar" } },
                { title: "Produto", key: "produto", scopedSlots: { customRender: "produto" } },
                { title: "Reabastecimento", key: "ressuprimento", align: "center", scopedSlots: { customRender: "ressuprimento" } },
                { title: "Fornecedores", key: "fornecedores", align: "right", scopedSlots: { customRender: "fornecedores" } },
                { title: "Valor total", key: "total", align: "right", scopedSlots: { customRender: "total" } },
                { title: "Ações", key: "acoes", width: 60, scopedSlots: { customRender: "acoes" } },
            ];
        },
        fornecedorColumns() {
            return [
                { title: "", key: "selecionar", width: 40, align: "center", scopedSlots: { customRender: "selecionar" } },
                { title: "Fornecedor", key: "fornecedor", scopedSlots: { customRender: "fornecedor" } },
                { title: "Emb", key: "embalagem", align: "center", width: 80, scopedSlots: { customRender: "embalagem" } },
                { title: "Valor unit.", key: "valor_unitario", align: "right", width: 100, scopedSlots: { customRender: "valor_unitario" } },
                { title: "Últ. Compra", key: "ultimaCompra", align: "right", width: 100, scopedSlots: { customRender: "ultimaCompra" } },
                { title: "Diferença", key: "diferenca", align: "right", width: 100, scopedSlots: { customRender: "diferenca" } },
                { title: "Variação", key: "variacao", align: "right", width: 90, scopedSlots: { customRender: "variacao" } },
                { title: "Cond. pagamento", key: "cond", scopedSlots: { customRender: "cond" } },
                { title: "Entrega prevista", key: "entrega", scopedSlots: { customRender: "entrega" } },
                { title: "Tipo de entrega", key: "tipoEntrega", scopedSlots: { customRender: "tipoEntrega" } },
                { title: "Fat. mín.", key: "faturamentoMinimo", align: "right", scopedSlots: { customRender: "faturamentoMinimo" } },
                { title: "Observação", key: "observacao", width: 240, scopedSlots: { customRender: "observacao" } },
                { title: "Lojas", key: "lojas", align: "right", scopedSlots: { customRender: "lojas" } },
                { title: "Valor", key: "valor", align: "right", scopedSlots: { customRender: "valor" } },
                { title: "Ações", key: "acoes", width: 60, scopedSlots: { customRender: "acoes" } },
            ];
        },
        lojaColumns() {
            return [
                { title: "Loja", key: "loja", scopedSlots: { customRender: "loja" } },
                { title: "Estoque", key: "estoque", align: "center", width: 70, scopedSlots: { customRender: "estoque" } },
                { title: "Requisição", key: "requisicao", align: "center", width: 90, scopedSlots: { customRender: "requisicao" } },
                { title: "Quantidade", key: "quantidade", align: "center", width: 100, scopedSlots: { customRender: "quantidade" } },
                { title: "Total", key: "total", align: "right", width: 100, scopedSlots: { customRender: "total" } },
                { title: "Ações", key: "acoes", width: 60, scopedSlots: { customRender: "acoes" } },
            ];
        },
        replenishmentOptions() {
            const seen = new Set();
            const options = [];

            this.products.forEach((row) => {
                const key = row.replenishment_strategy;

                if (!key || seen.has(key)) return;

                seen.add(key);
                options.push({ key, label: replenishmentLabel(key) });
            });

            return options.sort((a, b) => a.label.localeCompare(b.label));
        },
        filteredProducts() {
            const term = (this.search || "").trim().toLowerCase();

            return this.groupedProducts
                .filter((product) => {
                    if (this.replenishmentFilter.length && !this.replenishmentFilter.includes(product.replenishment_strategy)) return false;

                    return !term ||
                        (product.name || "").toLowerCase().includes(term) ||
                        (product.brand || "").toLowerCase().includes(term);
                })
                .map((product) => {
                    if (!this.storeFilter.length) return product;

                    const fornecedores = product.fornecedores
                        .map((fornecedor) => ({
                            ...fornecedor,
                            lojas: fornecedor.lojas.filter((offer) => this.storeFilter.some((id) => offer.store_id == id)),
                        }))
                        .filter((fornecedor) => fornecedor.lojas.length);

                    return { ...product, fornecedores };
                })
                .map((product) => {
                    if (!this.pendencyOnly) return product;

                    const fornecedores = product.fornecedores.filter(
                        (fornecedor) => fornecedor.minimumBilling && this.fornecedorTotal(fornecedor) < fornecedor.minimumBilling
                    );

                    return { ...product, fornecedores };
                })
                .filter((product) => product.fornecedores.length)
                .sort((a, b) => {
                    const nameA = (a.name || "").toUpperCase();
                    const nameB = (b.name || "").toUpperCase();
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                });
        },
        filteredTotal() {
            return this.filteredProducts.reduce((sum, product) => sum + this.productTotal(product), 0);
        },
        selectedOffers() {
            const keys = new Set(this.selectedOfferKeys);
            const offers = [];

            this.groupedProducts.forEach((product) => {
                product.fornecedores.forEach((fornecedor) => {
                    fornecedor.lojas.forEach((offer) => {
                        if (keys.has(offer.key)) offers.push(offer);
                    });
                });
            });

            return offers;
        },
        selectedTotal() {
            return this.selectedOffers.reduce((sum, offer) => sum + this.offerTotal(offer), 0);
        },
    },
    methods: {
        isPriceLocked(productId, sellerId) {
            return !!this.orderedOffers[`${productId}-${sellerId}`];
        },
        replenishment(product) {
            return replenishmentLabel(product.replenishment_strategy)
        },
        storeName(storeId) {
            const store = this.stores.find(s => s.id == storeId)
            return store ? store.name : "—"
        },
        deliveryDate(fornecedor) {
            if (!fornecedor.expected_date) return "-"
            return this.$options.filters.formatDateOnly(fornecedor.expected_date)
        },
        deltaClass(offer) {
            if (offer.offer_price > offer.last_purchase) return "vpm-up"
            if (offer.offer_price < offer.last_purchase) return "vpm-down"
            return ""
        },
        variation(offer) {
            if (!offer.last_purchase) return 0
            return ((offer.offer_price - offer.last_purchase) / offer.last_purchase) * 100
        },
        offerTotal(offer) {
            return (offer.requested_quantity || 0) * (
                offer.is_generic == 0 && offer.main_product_id == null
                    ? parseInt(offer.packing.split(' ')[1]) * offer.offer_price
                    : offer.offer_price
            )
        },
        fornecedorTotal(fornecedor) {
            return fornecedor.lojas.reduce((sum, offer) => sum + this.offerTotal(offer), 0)
        },
        productTotal(product) {
            return product.fornecedores.reduce((sum, fornecedor) => sum + this.fornecedorTotal(fornecedor), 0)
        },
        setSelection(keys) {
            this.$emit('update:selectedOfferKeys', keys);
        },
        lojaRowSelection(fornecedor) {
            const keys = fornecedor.lojas.map((offer) => offer.key);

            return {
                selectedRowKeys: keys.filter((key) => this.selectedOfferKeys.includes(key)),
                onChange: (selectedRowKeys) => {
                    const otherKeys = this.selectedOfferKeys.filter((key) => !keys.includes(key));
                    this.setSelection([...otherKeys, ...selectedRowKeys]);
                },
            };
        },
        // "Select all" (whichever level) only ever ADDS offers with a
        // quantity typed in — there is nothing to gerar pedido/zerar for an
        // untouched (qty 0) offer. Unselecting still clears everything,
        // including any zero-qty offer selected individually via its own
        // leaf checkbox.
        selectableKeys(offers) {
            return offers.filter((offer) => Number(offer.requested_quantity) > 0).map((offer) => offer.key);
        },
        isFornecedorFullySelected(fornecedor) {
            const keys = this.selectableKeys(fornecedor.lojas);
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isFornecedorPartiallySelected(fornecedor) {
            const keys = this.selectableKeys(fornecedor.lojas);
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleFornecedorSelection(fornecedor, checked) {
            if (checked) {
                const keys = this.selectableKeys(fornecedor.lojas);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = fornecedor.lojas.map((offer) => offer.key);
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        isProductFullySelected(product) {
            const keys = this.selectableKeys(product.fornecedores.flatMap((fornecedor) => fornecedor.lojas));
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isProductPartiallySelected(product) {
            const keys = this.selectableKeys(product.fornecedores.flatMap((fornecedor) => fornecedor.lojas));
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleProductSelection(product, checked) {
            const offers = product.fornecedores.flatMap((fornecedor) => fornecedor.lojas);

            if (checked) {
                const keys = this.selectableKeys(offers);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = offers.map((offer) => offer.key);
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        isAllFullySelected() {
            const keys = this.selectableKeys(this.filteredProducts.flatMap((product) => product.fornecedores.flatMap((fornecedor) => fornecedor.lojas)));
            return keys.length > 0 && keys.every((key) => this.selectedOfferKeys.includes(key));
        },
        isAllPartiallySelected() {
            const keys = this.selectableKeys(this.filteredProducts.flatMap((product) => product.fornecedores.flatMap((fornecedor) => fornecedor.lojas)));
            const selectedCount = keys.filter((key) => this.selectedOfferKeys.includes(key)).length;
            return selectedCount > 0 && selectedCount < keys.length;
        },
        toggleAllSelection(checked) {
            const offers = this.filteredProducts.flatMap((product) => product.fornecedores.flatMap((fornecedor) => fornecedor.lojas));

            if (checked) {
                const keys = this.selectableKeys(offers);
                this.setSelection(Array.from(new Set([...this.selectedOfferKeys, ...keys])));
                return;
            }

            const allKeys = offers.map((offer) => offer.key);
            this.setSelection(this.selectedOfferKeys.filter((key) => !allKeys.includes(key)));
        },
        handleFocus(offer) {
            const column = this.stores.find(s => s.id == offer.store_id)

            this.$emit('cell-focus', offer, column ? column.position : offer.store_id, this.filteredProducts)
        },
        saveQuantity(offer) {
            this.$emit('save-quantity', {
                key: offer.key,
                product_id: offer.id,
                store_id: offer.store_id,
                seller_id: offer.seller_id,
            })
        },
        handleQuantityInput(event, offer) {
            let value = event.target.value.replace(/\D/g, '')

            value = value.replace(/^0+(?=\d)/, '')

            if (+value > 999999) {
                value = '999999'
            }

            offer.requested_quantity = value
            this.$emit('quantity-edited', { key: offer.key, requested_quantity: value });

            event.target.value = value
        },
        handleQtyKeydown(event) {
            if (
                !['Enter', 'ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)
            ) {
                return
            }

            event.preventDefault()

            const inputs = Array.from(
                document.querySelectorAll('input.ant-input')
            ).filter(
                el => el.dataset.field === 'produto-qty'
            )

            const currentIndex = inputs.indexOf(event.target)

            if (currentIndex === -1) {
                return
            }

            const forward = ['Enter', 'ArrowDown', 'ArrowRight'].includes(event.key)

            const nextIndex = Math.max(
                0,
                Math.min(currentIndex + (forward ? 1 : -1), inputs.length - 1)
            )

            const nextInput = inputs[nextIndex]

            if (nextInput) {
                nextInput.focus()
                nextInput.select()
            }
        },
        bulkGenerateOrder() {
            if (!this.selectedOffers.length) return;

            this.confirm_action({
                message: `Gerar pedido para ${this.selectedOffers.length} oferta(s) selecionada(s)?`,
                confirm_text: "Gerar pedidos",
                callback: () => {
                    this.$emit('generate-orders', this.selectedOfferKeys);
                },
            });
        },
        bulkZeroQuantity() {
            if (!this.selectedOffers.length) return;

            this.confirm_action({
                message: `Zerar a quantidade de ${this.selectedOffers.length} oferta(s) selecionada(s)?`,
                confirm_text: "Zerar quantidade",
                callback: () => {
                    const keys = this.selectedOffers.map((offer) => offer.key);

                    Promise.all(
                        this.selectedOffers.map((offer) => {
                            offer.requested_quantity = 0;

                            return this.svc.sendQuantidade({
                                numerocotacao: this.$route.params.id,
                                quantidade: 0,
                                vendedor: offer.seller_id,
                                produto: offer.id,
                                loja: offer.store_id,
                            });
                        })
                    )
                        .then(() => {
                            keys.forEach((key) => this.$emit('quantity-synced', { key, requested_quantity: 0 }));
                            this.snack("Quantidades zeradas com sucesso.");
                            this.setSelection([]);
                        })
                        .catch((error) => {
                            this.snack("Não foi possível zerar uma ou mais quantidades.", "error");
                            ErrorHandlerService.handle(error, this.$store);
                        });
                },
            });
        },
        bulkExport() {
            if (!this.selectedOffers.length) return;

            const headers = ["Produto", "Marca", "Fornecedor", "Vendedor", "Loja", "Valor", "Quantidade", "Total"];

            const rows = this.selectedOffers.map((offer) => [
                offer.name,
                offer.brand || "",
                offer.provider_name,
                offer.seller_name || "",
                this.storeName(offer.store_id),
                offer.offer_price,
                offer.requested_quantity || 0,
                this.offerTotal(offer),
            ]);

            const csv = [headers, ...rows]
                .map((row) => row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(";"))
                .join("\n");

            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `pre-pedidos-produtos-${this.$route.params.id}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            this.setSelection([]);
        },
        produtoActions(product) {
            return [
                { label: "Alterar vencedor", icon: "emoji_events", iconClass: "action-teal", onClick: () => this.openChangeWinner(product) },
                { label: "Histórico de pedidos", icon: "assignment", iconClass: "action-teal", onClick: () => this.openHistory(product) },
                { label: "Alterar tipo de reabastecimento", icon: "sync_alt", iconClass: "action-primary", disabled: this.savingReplenishment === product.id, onClick: () => this.promptReplenishmentStrategy(product) },
            ];
        },
        openHistory(product) {
            this.historyModal = {
                open: true,
                productId: Number(product.id),
                productName: product.name,
            };
        },
        fornecedorActions(product, fornecedor) {
            const priceLocked = this.isPriceLocked(product.id, fornecedor.seller_id);

            return [
                { label: "Gerar pedido", icon: "local_shipping", iconClass: "action-primary", disabled: this.sending[fornecedor.key] || this.generating, onClick: () => this.sendFornecedor(fornecedor) },
                { label: "Negociar preço", icon: "handshake", iconClass: "action-success", disabled: priceLocked, tooltip: priceLocked ? PRICE_LOCKED_TOOLTIP : null, onClick: () => this.openNegotiation(product, fornecedor) },
                { label: "Alterar embalagem", icon: "inventory_2", iconClass: "action-warning", onClick: () => this.openWrap(product, fornecedor) },
                { label: "Ver pré-pedido do vendedor", icon: "shopping_cart", iconClass: "action-info", onClick: () => this.openSellerPreOrder(fornecedor) },
                { label: "Ver produtos digitados", icon: "inventory_2", iconClass: "action-teal", onClick: () => this.openTypedProducts(fornecedor) },
                { label: "Adicionar produto", icon: "add_box", iconClass: "action-success", onClick: () => this.openAddProduct(fornecedor) },
            ];
        },
        openAddProduct(fornecedor) {
            const provider = buildSellerProviderMatrix(
                this.products,
                fornecedor.seller_id,
                fornecedor.provider_id,
                this.stores
            );

            if (!provider) return;

            this.addProductModal = { open: true, provider };
        },
        closeAddProduct() {
            this.addProductModal.open = false;
        },
        parsePackagingMultiplier(packing) {
            const value = parseInt(String(packing || "").split(" ")[1], 10);
            return Number.isFinite(value) && value > 0 ? value : 1;
        },
        openDistributionForNewProduct(product) {
            const provider = this.addProductModal.provider;
            const packagingMultiplier = this.parsePackagingMultiplier(product.pro_embalagem);

            this.addProductModal.open = false;

            this.$nextTick(() => {
                this.distributionModal = {
                    open: true,
                    winner: {
                        pro_id: product.pro_id,
                        idVendedor: provider.seller_id,
                        valor: 0,
                        nomeFornecedor: provider.nomeFornecedor,
                        nomeVendedor: provider.nomeVendedor,
                        embalagem: packagingMultiplier,
                    },
                    product: {
                        descricaoProduto: product.pro_descricao,
                        flag_generico: product.pro_generico,
                        qtd_embalagem: packagingMultiplier,
                        ean: product.pro_ean,
                        internal_code: product.pro_codInterno,
                    },
                    markWinnerOnSave: true,
                };
            });
        },
        closeDistribution() {
            this.distributionModal.open = false;
        },
        onDistributionSaved() {
            this.distributionModal.open = false;
            this.$emit('reload');
        },
        sendFornecedor(fornecedor) {
            const keys = this.selectableKeys(fornecedor.lojas);

            if (!keys.length) {
                this.snack("Nenhuma quantidade informada para gerar pedido.", "error");
                return;
            }

            this.confirm_action({
                message: `Gerar pedido para ${fornecedor.provider_name}?`,
                confirm_text: "Gerar pedido",
                callback: () => {
                    this.$set(this.sending, fornecedor.key, true);
                    this.$emit('generate-orders', keys);
                },
            });
        },
        openSellerPreOrder(fornecedor) {
            const provider = buildSellerProviderMatrix(
                this.products,
                fornecedor.seller_id,
                fornecedor.provider_id,
                this.stores
            );

            if (!provider) return;

            this.sellerPreOrderModal = { open: true, provider };
        },
        closeSellerPreOrder() {
            this.sellerPreOrderModal.open = false;
        },
        openTypedProducts(fornecedor) {
            this.typedProductsModal = {
                open: true,
                providerId: fornecedor.provider_id,
                providerName: fornecedor.provider_name,
                sellerId: fornecedor.seller_id,
                sellerName: fornecedor.seller_name,
            };
        },
        closeTypedProducts() {
            this.typedProductsModal.open = false;
        },
        offerActions(offer) {
            return [
                { label: "Análise de giro", icon: "query_stats", iconClass: "action-info", onClick: () => this.$emit("giro", offer, this.filteredProducts) },
            ];
        },
        openChangeWinner(record) {
            this.changeWinnerModal = {
                open: true,
                product: record,
            };
        },
        closeChangeWinner() {
            this.changeWinnerModal.open = false;
        },
        onWinnerChanged() {
            this.$emit('reload');
        },
        openNegotiation(product, fornecedor) {
            this.negotiationModal = {
                open: true,
                winner: {
                    idVendedor: fornecedor.seller_id,
                    idFornecedor: fornecedor.provider_id,
                    pro_id: product.id,
                    valor: fornecedor.offer_price,
                    nomeVendedor: fornecedor.seller_name,
                },
                product: {
                    produtoDescricao: product.name,
                    pro_observacao: product.brand,
                    observacao: fornecedor.observations,
                    ultimaCompra: fornecedor.last_purchase,
                },
            };
        },
        closeNegotiation() {
            this.negotiationModal.open = false;
            this.$emit('reload');
        },
        openWrap(product, fornecedor) {
            this.wrapModal = {
                open: true,
                winner: {
                    idVendedor: fornecedor.seller_id,
                    idFornecedor: fornecedor.provider_id,
                    pro_id: product.id,
                    embalagem: fornecedor.packing,
                },
                product: {
                    descricaoProduto: product.name,
                    embalagem: fornecedor.packing,
                    idProduto: product.id,
                    flag_generico: product.is_generic,
                    pro_principal: product.main_product_id,
                },
            };
        },
        closeWrap() {
            this.wrapModal.open = false;
            this.$emit('reload');
        },
        process_available_products() {
            this.products.forEach(pp => {
                let prod = this.groupedProducts.find(p => p.id == pp.id)

                if (!prod) {
                    prod = { ...pp, key: pp.id, fornecedores: [] }
                    this.groupedProducts.push(prod)
                }

                let fornecedor = prod.fornecedores.find(f => f.provider_id == pp.provider_id && f.seller_id == pp.seller_id)

                if (!fornecedor) {
                    fornecedor = {
                        key: `${pp.id}-${pp.provider_id}-${pp.seller_id}`,
                        provider_id: pp.provider_id,
                        provider_cnpj: pp.provider_cnpj,
                        provider_name: pp.provider_name,
                        seller_id: pp.seller_id,
                        seller_name: pp.seller_name,
                        observations: pp.observations,
                        minimumBilling: pp.minimum_billing,
                        payment_condition: pp.payment_condition,
                        expected_date: pp.expected_date,
                        delivery_type: pp.delivery_type,
                        packing: pp.packing,
                        purchase_unity: pp.purchase_unity,
                        offer_price: pp.offer_price,
                        last_purchase: pp.last_purchase,
                        lojas: [],
                    }
                    prod.fornecedores.push(fornecedor)
                }

                fornecedor.lojas.push({
                    ...pp,
                    key: `${pp.id}-${pp.store_id}-${pp.provider_id}-${pp.seller_id}`,
                })
            })
        },
        processProducts() {
            this.groupedProducts = [];
            this.process_available_products();
        },
        sort_stores() {
            this.stores.sort((a, b) => {
                if (a.position > b.position) return 1
                if (b.position > a.position) return -1
                return 0
            })
        },
        async loadStores() {
            this.stores = await this.$store.dispatch('user/fetch_stores')
            this.sort_stores()
        },
    },
    created() {
        this.loadStores();
    },
    watch: {
        products: {
            immediate: true,
            handler(value) {
                if (!value || !value.length) return;
                this.processProducts();
            }
        },
        products_loading(loading) {
            if (!loading) this.sending = {};
        },
    },
};
</script>

<style lang="scss" scoped>
.bl-card {
    --pri: var(--primary-color);
    width: 100%;

    ::v-deep(.ant-card-body) {
        width: 100%;
        padding: 0;
    }
}
::v-deep(.ant-table-expanded-row > td) {
    padding: 0 !important;
    max-width: 0;
}
::v-deep(.ant-table-expanded-row) {
    overflow: hidden;
}
.expanded-table-wrapper {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
}
.bl-filterbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
}
.fl-filter-select {
    width: 220px;
}
.fl-filter-select-loja {
    width: 260px;
}
.fixed-height-select.ant-select,
.fixed-height-select ::v-deep(.ant-select-selection--multiple) {
    min-height: 32px !important;
    max-height: 32px !important;
    overflow: auto;
}
.bl-stats {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: auto;
}
.bl-stat {
    font-size: 13px;
    color: #595959;

    b {
        color: #262626;
        font-weight: 600;
    }
}
.bl-search-input {
    flex: 1 1 160px;
    min-width: 140px;
    max-width: 260px;
}
.bl-strong {
    font-weight: 600;
    color: #262626;
}
.bl-sup {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.bl-n {
    font-weight: 600;
    color: #262626;
}
.bl-v {
    font-size: 12px;
    color: #8c8c8c;
    font-style: italic;
}
.obs-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: bottom;
    color: #595959;
}
.repl-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 10px;
    background: #f0f0f0;
    color: #595959;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}
.pro-name {
    display: flex;
    align-items: center;
    gap: 6px;
}
.brand {
    color: #999;
    font-size: 12px;
}
.vpm-up {
    color: #cf1322;
    font-weight: 600;
}
.vpm-down {
    color: #389e0d;
    font-weight: 600;
}
.pro-ean {
    font-size: 11px;
    color: #8c8c8c;
}
.matrix-qty-input {
    width: 70px;
    text-align: center;

    .ant-input {
        padding: 2px 4px;
    }
}
.matrix-qty-wrap {
    display: contents;
}
.matrix-qty-wrap.saved ::v-deep(.ant-input) {
    background-color: #13c7213d;
    color: green !important;
}
.matrix-suggested {
    font-size: 11px;
    color: #8c8c8c;
    text-align: center;
    margin-top: 2px;
    white-space: nowrap;
}
</style>
